import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Pianifica, StatoPianifica } from '../../_models/Pianificazione';

// Feature 081 (issue #3005) — selettore mostrato quando esistono PIÙ pianifiche con la nuova data
// di consegna, dopo lo scollegamento server-side dell'OdV. standalone: false e dichiarato in
// SharedModule (come ordine-vendita-create che lo apre, riusabile anche dal contesto pianificazione).
@Component({
  selector: 'app-seleziona-pianifica-modal',
  templateUrl: './seleziona-pianifica-modal.component.html',
  standalone: false
})
export class SelezionaPianificaModalComponent {
  @Input() pianifiche: Pianifica[] = [];

  constructor(private modalController: ModalController) {}

  // Scelta → l'ordine verrà ri-collegato a questa pianifica dal chiamante (FR-009/FR-010).
  select(pianifica: Pianifica): void {
    this.modalController.dismiss(pianifica, 'confirm');
  }

  // Chiusura senza scelta → l'ordine resta scollegato con la nuova data (FR-011).
  close(): void {
    this.modalController.dismiss(null, 'cancel');
  }

  statoLabel(stato: StatoPianifica): string {
    switch (stato) {
      case StatoPianifica.Bozza:      return 'Bozza';
      case StatoPianifica.Confermata: return 'Confermata';
      case StatoPianifica.InCorso:    return 'In Corso';
      case StatoPianifica.Completata: return 'Completata';
      default:                        return '';
    }
  }
}
